import { Table } from 'foundations-components/transitional/components/Table';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useRecentCompletedPlaylists } from '../../queries/playlistQueries';
import { NavMarker } from 'react-rhumb';
import ApiError from '../../../../components/Errors/ApiError';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { getPaginatedPosition } from '../../utils/paginationUtils';
import UserAvatarLink from '../common/UserAvatarLink';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import PlaylistLink from '../playlists/PlaylistLink';
import { MY_TEAM_OVERVIEW_PAGE_SIZE } from '../../../pagination';
import EmptyOverviewCard from '../common/EmptyOverviewCard';
import { usePaginatedTable } from '../../hooks/usePaginatedTable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const RecentCompletedPlaylists = () => {
  const {
    isDesktop,
    isMobile
  } = useMediaQuery();
  const {
    recentCompletedPlaylists,
    recentCompletedPlaylistsLoading,
    recentCompletedPlaylistsError
  } = useRecentCompletedPlaylists();
  const {
    startIndex,
    paginatedData: playlistsToDisplay,
    pageCount,
    pageNumber,
    handlePageChange
  } = usePaginatedTable(recentCompletedPlaylists, MY_TEAM_OVERVIEW_PAGE_SIZE);
  if (recentCompletedPlaylistsLoading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      layout: "centered",
      minHeight: "350px",
      size: "medium"
    });
  }
  if (recentCompletedPlaylistsError || !recentCompletedPlaylists) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "RECENT_COMPLETED_PLAYLISTS_API_ERROR",
      children: /*#__PURE__*/_jsx(ApiError, {
        error: {
          status: 500
        }
      })
    });
  }
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "RECENT_COMPLETED_PLAYLISTS_LOADED",
    children: playlistsToDisplay.length > 0 ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Table, {
        condensed: true,
        "data-test-id": "recent-completed-playlists-table",
        truncated: isMobile,
        children: [/*#__PURE__*/_jsxs("colgroup", {
          children: [/*#__PURE__*/_jsx("col", {
            width: "40%"
          }), /*#__PURE__*/_jsx("col", {
            width: "35%"
          }), /*#__PURE__*/_jsx("col", {
            width: "25%"
          })]
        }), /*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.overview.playlists.recentCompletedPlaylists.table.name"
              })
            }), /*#__PURE__*/_jsx("th", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.overview.playlists.recentCompletedPlaylists.table.playlist"
              })
            }), /*#__PURE__*/_jsx("th", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.overview.playlists.recentCompletedPlaylists.table.completed"
              })
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: playlistsToDisplay.map((playlist, index) => {
            const position = getPaginatedPosition(startIndex, index);
            return /*#__PURE__*/_jsxs("tr", {
              "data-test-id": "recent-completed-playlist-row",
              children: [/*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(UserAvatarLink, {
                  displayAvatar: isDesktop,
                  position: position,
                  userEmail: playlist.userEmail,
                  userId: playlist.userId,
                  userName: playlist.userName
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(PlaylistLink, {
                  playlistId: playlist.playlistId,
                  playlistName: playlist.playlistName,
                  position: position
                })
              }), /*#__PURE__*/_jsx("td", {
                children: playlist.completedDate && /*#__PURE__*/_jsx(FormattedDateTime, {
                  format: "ll",
                  value: playlist.completedDate
                })
              })]
            }, `${playlist.userId}-${playlist.playlistId}`);
          })
        })]
      }), /*#__PURE__*/_jsx(Paginator, {
        onPageChange: handlePageChange,
        page: pageNumber,
        pageCount: pageCount,
        showButtonLabels: false
      })]
    }) : /*#__PURE__*/_jsxs(EmptyOverviewCard, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myTeam.overview.playlists.recentCompletedPlaylists.noResultsTitle"
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myTeam.overview.playlists.recentCompletedPlaylists.noResultsDescription"
      })]
    })
  });
};
export default RecentCompletedPlaylists;